import { apiRequest } from "../http";

export interface NoteTypeOption {
  id: string;
  name: string;
  label: string;
  icon?: string;
  color?: string;
  description?: string;
  promptInstructions?: string;
  isSystem: boolean;
  isDefault?: boolean;
}

export const fetchNoteTypes = () =>
  apiRequest<NoteTypeOption[]>("/api/note-types");

export const createNoteType = (data: {
  name: string;
  label: string;
  icon?: string;
  color?: string;
  description?: string;
  promptInstructions?: string;
}) =>
  apiRequest<NoteTypeOption>("/api/note-types", {
    method: "POST",
    body: data,
  });

export const updateNoteType = (
  id: string,
  data: {
    label?: string;
    icon?: string;
    color?: string;
    description?: string;
    promptInstructions?: string;
  },
) =>
  apiRequest<NoteTypeOption>(`/api/note-types/${id}`, {
    method: "PUT",
    body: data,
  });

export const deleteNoteType = (id: string) =>
  apiRequest<void>(`/api/note-types/${id}`, {
    method: "DELETE",
  });

export const detectNoteType = (noteId: string) =>
  apiRequest<{
    noteId: string;
    detection?: {
      suggestedType?: string;
    };
  }>("/api/detect-note-type", {
    method: "POST",
    body: { noteId },
  });
